import React, { useState } from 'react';

const getLocalDateString = (dateObj = new Date()) => {
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export default function MobileAsCalendar({ asList, loading }) {
  const [selectedDate, setSelectedDate] = useState(getLocalDateString());

  // 선택한 날짜 기준 주간 리스트 동적 추출 함수
  const getDynamicWeekDates = (baseDateStr) => {
    const current = new Date(baseDateStr);
    const day = current.getDay();
    const distanceToMonday = current.getDate() - day + (day === 0 ? -6 : 1);
    
    return ['월', '화', '수', '목', '금'].map((label, idx) => {
      const targetDate = new Date(current.getFullYear(), current.getMonth(), distanceToMonday + idx);
      return {
        label: `${label}(${targetDate.getDate()}일)`,
        fullDate: `${targetDate.getFullYear()}-${String(targetDate.getMonth() + 1).padStart(2, '0')}-${String(targetDate.getDate()).padStart(2, '0')}`
      };
    });
  };

  const dynamicWeekRange = getDynamicWeekDates(selectedDate);

  // PC 달력(AsReserve)과 같은 기준으로 찾는다 — 접수일 '또는' 정산일 (2026-09-23)
  //   예전에는 asDate(접수일)만 봤다. 그래서 9/21 에 접수해 9/22 에 정산한 건이
  //   PC 달력 9/22 칸에는 뜨는데 모바일 9/22 에는 아무것도 없었다.
  //   한 건이 접수일과 정산일 두 날짜에 모두 보이는 것은 PC 와 같은 동작이다.
  const filteredRecords = asList.filter(
    item => item.asDate === selectedDate || item.settleDate === selectedDate
  );

  return (
    <div style={{ padding: '16px', boxSizing: 'border-box' }}>
      
      {/* 날짜 선택 인풋 피커 */}
      <div style={{ background: '#ffffff', padding: '12px 16px', borderRadius: '16px', border: '1px solid #e2e8f0', marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 2px 4px rgba(0,0,0,0.01)' }}>
        <label style={{ fontSize: '13px', fontWeight: '800', color: '#475569' }}>📅 원하시는 날짜 선택:</label>
        <input type="date" value={selectedDate} onChange={(e) => { if (e.target.value) setSelectedDate(e.target.value); }} style={{ border: '1px solid #cbd5e1', borderRadius: '10px', padding: '6px 10px', fontSize: '14px', fontWeight: '700', color: '#1e293b', outline: 'none' }} />
      </div>

      {/* 주간 슬라이더 탭바 */}
      <div style={{ display: 'flex', gap: '6px', marginBottom: '16px', overflowX: 'auto', paddingBottom: '6px', WebkitOverflowScrolling: 'touch' }}>
        {dynamicWeekRange.map((item, idx) => {
          const isCurrentActive = selectedDate === item.fullDate;
          return (
            <button key={idx} onClick={() => setSelectedDate(item.fullDate)} style={{ background: isCurrentActive ? '#007bff' : '#ffffff', color: isCurrentActive ? '#fff' : '#64748b', padding: '10px 14px', borderRadius: '20px', border: isCurrentActive ? 'none' : '1px solid #e2e8f0', minWidth: '85px', fontSize: '12px', fontWeight: '700', cursor: 'pointer', outline: 'none' }}>
              {item.label}
            </button>
          );
        })}
      </div>

      {loading && <div style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>로딩 중...</div>}
      
      {!loading && filteredRecords.length === 0 && (
        <div style={{ textAlign: 'center', color: '#94a3b8', padding: '40px 20px', background: '#ffffff', borderRadius: '16px', border: '1px solid #e2e8f0', fontSize: '13px' }}>📭 배정된 정비 내역이 없습니다.</div>
      )}

      {/* 🚀 정비 리스트 내역 노출 카드 섹션 */}
      {!loading && filteredRecords.map((record) => (
        <div key={record.id} style={{ background: '#ffffff', padding: '16px', borderRadius: '16px', boxShadow: '0 2px 4px rgba(0,0,0,0.02)', border: '1px solid #e2e8f0', marginBottom: '12px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <div style={{ display: 'flex', gap: '6px' }}>
              <span style={{ fontSize: '11px', background: record.status === '접수' ? '#fef3c7' : record.status === '예약' ? '#f3e8ff' : '#d1fae5', color: record.status === '접수' ? '#d97706' : record.status === '예약' ? '#9333ea' : '#059669', padding: '3px 8px', borderRadius: '12px', fontWeight: '700' }}>{record.status || '접수'}</span>
              
              {/* 예약 시간 배지 항시 좌상단 노출 고정 */}
              <span style={{ fontSize: '11px', background: '#e0f2fe', color: '#0369a1', padding: '3px 8px', borderRadius: '12px', fontWeight: '700' }}>⏰ {record.asTime || '시간미정'}</span>
            </div>
            <span style={{ fontSize: '13px', color: '#334155', fontWeight: '700' }}>{record.carNumber}</span>
          </div>

          {/* 🚀 [버그 수정 완료] 기존 record.subject 대신 대시보드와 동일하게 실제 입력 내용인 record.symptom을 표출합니다. */}
          <h3 style={{ margin: '0 0 10px 0', fontWeight: '800', fontSize: '15px', color: '#1e293b' }}>
            {record.symptom || '일반 정비 수립 건'}
          </h3>
          
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px', color: '#64748b', borderTop: '1px solid #f1f5f9', paddingTop: '8px' }}>
            <span>👤 고객: <span style={{ color: '#1e293b', fontWeight: '600' }}>{record.customerName}</span></span>
            <span>👨‍🔧 담당: <span style={{ color: '#1e293b', fontWeight: '600' }}>{record.mechanic || '미지정'}</span></span>
          </div>
        </div>
      ))}
    </div>
  );
}